// ----------------------------------------------------------------------

import { globalDashboardIt } from './modules/globalDashboard.it';
import { privacyIt } from './modules/privacy.it';
import { analyticsIt } from './modules/analytics.it';
import { stripeConnectIt } from './modules/stripeConnect.it';

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to instadrinkpro@gmail.com.

// ----------------------------------------------------------------------

const it = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  create_event: 'Create an event',
  label_Rows_Per_Page: 'Rows per page',
  created_At: 'Created at',
  location: 'Location',
  title: 'title',
  events: 'Events',
  archived: 'Archived',
  canceled: 'canceled',
  Start_Date: 'Start Date',
  End_Date: 'End Date',
  organisation: 'Organisation',
  organisations: 'Organisations',

  published_events: 'Published Events',
  Add_event: 'Add Event',
  event_name: 'Event Name',
  summary: 'Summary',
  cancel: 'Cancel',
  add: 'Add',
  view_event: 'View Event ',
  event_title: 'Event Title',
  cover: 'Cover',
  category: 'Category',
  sub_category: 'SubCategory',
  status: 'Status',
  listed: 'Listed',
  online_event: 'Online Event',
  tags: 'Tags',
  address: 'Address',
  city: 'City',
  capacity: 'Capacity',
  save: 'Save',
  Start_Time: 'Start Time',
  End_Time: 'End Time',
  timezone: 'Timezone',
  Save_Changes: 'Save Changes',
  Quantity: 'Quantity',
  Initial_Quantity: 'Quantità disponibile',
  Max_Quantity: 'Max per order',
  price: 'Price',
  free: 'Free',
  Sell_Time_Limit: 'Sell Time Limit',
  delete: 'Delete',
  Edit: 'Edit',
  Add_Ticket: 'Add Ticket',
  Sell_limit: 'Sell limit',
  start: 'Start',
  end: 'End',
  Access_Time_Limit: "Orario di accesso all'evento",
  Access_Time_Thresholdt: "Ora di fine dell'accesso all'evento",
  Price_Quantity: 'Price and Quantity',
  Access_limit: 'Access limit',
  send_invitation: 'Invia invito',
  name: 'Name',
  Your_event_is_already_published_on_this_link: 'Your event is already published on this link',
  archive: 'Archive',
  Event_Dashboard: 'Event Dashboard',
  Preview_Event: 'Preview Event',
  publish: 'Publish',
  Email_Message: "Testo dell'e-mail inviata ai partecipanti all'evento",
  Ticket_Message: 'Ticket Message',
  include: 'Include',
  required: 'Required',
  Gender: 'Gender',
  Birthday: 'Birthday',
  HomePhone: 'Home Phone',
  yourEventIs: 'Your event is ',
  date: 'Date',
  events_catering: 'Eventi e gastronomia',
  events_catering_description:
    'ID è una piattaforma che consente ai clienti di acquistare i biglietti per i vostri eventi e di ordinare cibo e bevande in formato digitale dal vostro locale',
  create_digital_exp: 'Create la vostra esperienza digitale',
  create_digital_exp_description:
    'I clienti interagiscono con il vostro marchio, a modo vostro; voi controllate la vostra presenza digitale per massimizzare i ricavi e la redditività.',
  digital_ticketing: 'BIGLIETTERIA DIGITALE',
  digital_ticketing_title:
    'Aggiungete i vostri eventi e vendete i biglietti sulla nostra piattaforma.',
  digital_ticketing_description:
    'Tutti i vostri clienti che desiderano partecipare possono cliccare su un link o scansionare un codice QR sul volantino digitale o fisico del vostro evento; questo li indirizzerà alla piattaforma ID dove potranno scegliere e pagare il loro biglietto.',
  more_questions: 'Avete ancora domande?',
  more_questions_description: 'Descrivete il vostro caso per ricevere una consulenza più accurata.',
  who_are_we: {
    who: 'Chi ',
    are: 'siamo',
    you: '',
    work: 'Lavoriamo insieme per',
    futur: 'un futuro migliore negli eventi e ristorazione',
  },
  what_is_id: {
    title: "Che cos'è ID?",
    description:
      'ID è una piattaforma che consente ai clienti di acquistare i biglietti per partecipare ai vostri eventi e di ordinare cibo e bevande in formato digitale presso il vostro locale.',
  },
  about: {
    vision:
      'La nostra visione: Offrire la piattaforma perfetta per un futuro migliore nel settore degli eventi e della ristorazione.',
    dream_team: 'SQUADRA DEI SOGNI ',
    dream_team_description:
      'ID vi fornirà assistenza in caso di problemi. Il nostro team di supporto risponderà. Un buon team è la chiave. Entro un giorno, e abbiamo anche una documentazione completa.',
  },
  testimonials: {
    title: 'TESTIMONIANZE',
    who: 'A chi piace ',
    service: ' il nostro servizio?',
    description:
      'Il nostro obiettivo è creare una piattaforma perfetta che soddisfi tutti i nostri clienti di eventi e catering. Per questo motivo lavoriamo costantemente sui nostri servizi per migliorarli ogni giorno, ascoltando i preziosi suggerimenti che i nostri utenti condividono con noi.',
  },
  warning_message: 'Premi prima "aggiungi" per salvare il tuo biglietto e continuare',
  restaurants: 'Ristoranti',
  stores: 'Negozi',
  commandes: 'Ordini',
  applications: 'Applicazioni',
  inviteUsers: 'Invita utenti',
  inviteAgents: 'Invita agenti',
  inviteStaff: 'Invita personale',
  invitationsList: 'Elenco inviti',
  promotersTree: 'Albero dei inviti',
  promotionGroups: 'Gruppi di PromoBoosters',
  onboarding: 'Onboarding',
  enhanced_organization: {
    address_requires_coordinates: 'Seleziona un indirizzo valido dai suggerimenti',

    // Step Labels
    step_labels: {
      basic: 'Informazioni di base',
      contact: 'Informazioni di contatto',
      type: "Tipo d'organizzazione",
      roles: 'Ruoli del personale',
      staff: 'Membri del team',
      features: 'Funzionalità e impostazioni',
      availability: 'Disponibilità e orari',
      showcase: 'Vetrina musicale',
      quick_setup: 'Configurazione rapida',
    },

    // Dialog Title and General
    create_organization: 'Crea organizzazione',
    step: 'Passaggio',
    of: 'di',
    quick_mode: 'Modalità rapida',
    quick_setup: 'Configurazione rapida',
    music_studio: 'Studio musicale',

    // Basic Information Step
    tell_us_about_organization: 'Parlaci della tua organizzazione',
    basic_info_subtitle: 'Iniziamo con le informazioni di base',
    organization_name: "Nome dell'organizzazione",
    organization_name_required: "Nome dell'organizzazione *",
    organization_name_exists: "Il nome dell'organizzazione esiste già",
    description: 'Descrizione',
    description_required: 'Descrizione *',
    language: 'Lingua',
    organization_logo: "Logo dell'organizzazione",
    upload_logo: 'Carica logo',
    cover_image: 'Immagine di copertina',
    upload_cover_image: 'Carica immagine di copertina',
    change_logo: 'Cambia logo',

    // Quick Mode
    quick_setup_mode: 'Modalità di configurazione rapida',
    using_quick_setup:
      'Utilizzando la configurazione rapida con impostazioni predefinite - disattiva per configurazione dettagliata',
    skip_detailed_setup:
      'Salta la configurazione dettagliata e usa i valori predefiniti. Potrai modificare tutto in seguito.',
    detailed_setup: 'Configurazione dettagliata',

    // Contact Information Step
    contact_information: 'Informazioni di contatto',
    contact_info_subtitle: 'Fornisci i dettagli di contatto e indirizzo del tuo studio',
    email_address: 'Indirizzo email',
    main_contact_email: 'Email principale di contatto per lo studio',
    phone_number: 'Numero di telefono',
    contact_phone_number: 'Numero di telefono di contatto',
    website: 'Sito web',
    studio_website_optional: 'Sito web dello studio (facoltativo)',
    studio_address: 'Indirizzo dello studio',
    full_address_location: 'Indirizzo completo in cui si trova lo studio',
    location_verified: 'Posizione verificata',
    no_locations_found: 'Nessuna posizione trovata',
    contact_info_help:
      'Le informazioni di contatto aiutano i clienti a trovare e contattare il tuo studio. Puoi aggiornare questi dettagli in seguito nelle impostazioni.',

    // Type Selection Step
    creating_music_studio: 'Creazione di uno studio musicale',
    creating_studio_subtitle:
      "Stai creando un'organizzazione di studio di registrazione con funzionalità avanzate",
    what_type_organization: "Che tipo d'organizzazione è?",
    type_selection_subtitle: 'Questo ci aiuta a personalizzare l’esperienza per te',
    existing: 'Esistente',

    // Roles Setup Step
    set_up_staff_roles: 'Configura i ruoli del personale',
    roles_setup_subtitle:
      'Definisci i ruoli dei membri del tuo team. Puoi saltare questo passaggio.',
    use_recommended_roles: 'Usa i ruoli consigliati per questo tipo di organizzazione',
    recommended_roles: 'Ruoli consigliati',
    custom_roles: 'Ruoli personalizzati',
    role_name: 'Nome del ruolo',

    // Staff Setup Step
    add_team_members: 'Aggiungi membri del team',
    staff_setup_subtitle:
      'Aggiungi i membri del tuo team. Puoi sempre aggiungerne altri in seguito.',
    add_staff_member: 'Aggiungi membro del personale',
    add_new_staff_member: 'Aggiungi nuovo membro del personale',
    name: 'Nome',
    name_required: 'Nome *',
    email: 'Email',
    email_required: 'Email *',
    password: 'Password',
    leave_empty_default: 'Lascia vuoto per valore predefinito (123)',
    role: 'Ruolo',
    cancel: 'Annulla',
    add_member: 'Aggiungi membro',
    added_staff_members: 'Membri del personale aggiunti',
    custom_role: 'Ruolo personalizzato',

    // Availability Setup Step
    studio_availability: 'Disponibilità dello studio',
    availability_subtitle:
      'Configura gli orari di lavoro del tuo studio, gli slot di prenotazione e le regole di disponibilità',
    please_fix_issues: 'Correggi i seguenti problemi:',
    working_hours: 'Orari di lavoro',
    booking_rules: 'Regole di prenotazione',
    time_slots: 'Fasce orarie',
    weekly_schedule: 'Programma settimanale',
    weekly_schedule_subtitle:
      'Imposta gli orari di apertura del tuo studio per ogni giorno della settimana. Abilita la modalità 24 ore o imposta orari che attraversano la mezzanotte (es. 22:00 - 06:00)',

    // Cross-Day Booking Policy
    cross_day_booking_policy: 'Politica di prenotazione tra giorni',
    enable_cross_day_bookings: 'Abilita prenotazioni tra giorni',
    cross_day_help: 'Consenti prenotazioni che attraversano la mezzanotte (es. 23:00 - 2:00)',
    max_cross_day_hours: 'Ore massime tra giorni',
    max_cross_day_help: 'Durata massima che una prenotazione può estendersi tra più giorni',
    allow_weekend_crossover: 'Consenti incrocio weekend',
    weekend_crossover_help:
      'Permetti prenotazioni che si estendono dal weekend ai giorni feriali o viceversa',
    require_same_day_start: 'Richiedi inizio nello stesso giorno',
    same_day_start_help:
      'La prenotazione deve iniziare e terminare nello stesso giorno di calendario',

    // Days of Week
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',

    // Time Configuration
    start_time: 'Ora di inizio',
    end_time: 'Ora di fine',
    next_day: 'Giorno successivo',
    cross_midnight_schedule: 'Programma che attraversa la mezzanotte:',

    // Booking Configuration
    booking_configuration: 'Configurazione prenotazioni',
    booking_config_subtitle: 'Configura le regole e le restrizioni di prenotazione',
    advance_booking_days: 'Giorni di prenotazione anticipata',
    advance_booking_help: 'Quanti giorni in anticipo i clienti possono prenotare',
    minimum_notice_hours: 'Preavviso minimo (ore)',
    minimum_notice_help: 'Ore minime prima della prenotazione',
    max_session_duration: 'Durata massima sessione (minuti)',
    max_duration_help: 'Durata massima della prenotazione',
    buffer_time_minutes: 'Tempo di pausa (minuti)',
    buffer_time_help: 'Tempo di pausa tra prenotazioni',
    auto_approve_bookings: 'Approva automaticamente le prenotazioni',
    auto_approve_help:
      'Approva automaticamente le richieste di prenotazione senza revisione manuale',
    allow_back_to_back: 'Consenti prenotazioni consecutive',
    back_to_back_help: 'Consenti di pianificare prenotazioni consecutive',

    // Time Slot Configuration
    time_slot_configuration: 'Configurazione fasce orarie',
    time_slot_subtitle: 'Configura gli intervalli e le fasce orarie di prenotazione',
    time_slot_unit: 'Unità fascia oraria',
    default_slot_duration: 'Durata predefinita fascia (minuti)',
    slot_duration_help: 'Durata predefinita per le fasce di prenotazione',
    time_slot_help:
      'Le fasce orarie saranno generate in base agli orari di lavoro e all’unità selezionata. I clienti potranno scegliere tra le fasce disponibili durante la prenotazione.',

    // Actions
    reset_to_defaults: 'Ripristina predefiniti',
    current_settings_applied:
      'Le impostazioni attuali saranno applicate al termine della configurazione',
    availability_for_studios:
      'Le impostazioni di disponibilità sono progettate principalmente per studi di registrazione. Puoi modificarle in seguito nella dashboard se necessario.',
    skip_configure_later:
      'Puoi saltare questo passaggio e configurare la disponibilità più tardi nella dashboard. Queste impostazioni aiutano ad automatizzare il processo di prenotazione e l’esperienza del cliente.',

    // Showcase Setup Step
    music_showcase: 'Vetrina musicale',
    showcase_subtitle:
      'Imposta una vetrina musicale per mostrare il lavoro del tuo studio ai clienti',
    enable_music_showcase: 'Abilita vetrina musicale',
    showcase_enabled_help:
      'Quando attiva, la tua vetrina musicale sarà visibile ai clienti sul profilo dello studio',
    showcase_title: 'Titolo vetrina',
    showcase_title_placeholder: 'es. Le nostre ultime produzioni',
    showcase_description: 'Descrizione vetrina',
    showcase_description_placeholder: 'Descrivi la tua vetrina musicale...',
    add_music_tracks_later:
      'Puoi aggiungere brani musicali da YouTube, Spotify, SoundCloud e altre piattaforme dopo la configurazione.',
    showcase_for_studios:
      'La vetrina musicale è progettata specificamente per studi di registrazione. Questo passaggio può essere saltato per altri tipi di organizzazioni.',
    configure_showcase_later:
      'Non preoccuparti, potrai configurare la tua vetrina musicale in seguito nella dashboard.',

    // Quick Setup Step
    quick_setup_title: 'Configurazione rapida',
    quick_setup_subtitle_studio:
      'Crea il tuo studio musicale con una configurazione minima. Potrai personalizzare tutto in seguito.',
    quick_setup_subtitle_general:
      'Crea la tua organizzazione con una configurazione minima. Potrai personalizzare tutto in seguito.',
    contact_email: 'Email di contatto',
    contact_phone: 'Telefono di contatto',
    logo: 'Logo',
    optional: 'Facoltativo',
    studio_description_placeholder:
      'Descrivi il tuo studio musicale, le specialità e ciò che lo rende unico...',
    organization_description_placeholder: 'Descrivi la tua organizzazione e i suoi servizi...',

    // Default Settings Preview
    default_settings_applied: 'Impostazioni predefinite applicate',
    standard_working_hours: 'Orario di lavoro standard',
    basic_booking_settings: 'Impostazioni di prenotazione di base',
    default_roles: 'Ruoli predefiniti',
    core_features_enabled: 'Funzionalità principali abilitate',
    standard_availability_settings: 'Impostazioni di disponibilità standard',
    basic_notification_preferences: 'Preferenze di notifica di base',
    customize_settings_later:
      'Tutte le impostazioni possono essere personalizzate in seguito nella dashboard.',
    changed_your_mind: 'Hai cambiato idea?',
    switch_to_detailed:
      'Puoi passare alla configurazione dettagliata per impostare ruoli, personale, funzionalità e disponibilità passo dopo passo. Le informazioni di base saranno conservate.',

    // Navigation
    back: 'Indietro',
    skip: 'Salta',
    next: 'Avanti',
    complete_setup: 'Completa configurazione',

    // Validation Messages
    validation: {
      advance_booking_range: 'I giorni di prenotazione anticipata devono essere tra 1 e 365',
      minimum_notice_positive: 'Il preavviso minimo non può essere negativo',
      max_duration_minimum: 'La durata massima deve essere almeno di 15 minuti',
      slot_duration_minimum: 'La durata della fascia deve essere almeno di 15 minuti',
      buffer_time_positive: 'Il tempo di pausa non può essere negativo',
      reset_success: 'Impostazioni di disponibilità ripristinate ai valori predefiniti',
      fix_issues: 'Correggi i seguenti problemi:',
      advance_booking_days: 'I giorni di prenotazione anticipata devono essere un numero positivo',
      minimum_notice_hours: 'Le ore di preavviso devono essere un numero positivo',
      max_session_duration: 'La durata massima della sessione deve essere un numero positivo',
      buffer_time_minutes: 'Il tempo di pausa deve essere un numero positivo',
      default_slot_duration: 'La durata predefinita della fascia deve essere un numero positivo',
    },

    // Completion Messages
    organization_created_success: 'Organizzazione creata con successo!',
    create_organization_failed: 'Creazione organizzazione fallita',
    user_not_authenticated: 'Utente non autenticato',

    // Additional Translation Keys for Enhanced UI
    days: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica',
    },
    time_units: {
      fifteenMinutes: '15 minuti',
      thirtyMinutes: '30 minuti',
      oneHour: '1 ora',
    },
    placeholders: {
      contact_email: 'contact@studio.com',
      contact_phone: '+39 06 12 34 56 78',
    },
    alerts: {
      availability_reset: 'Impostazioni di disponibilità ripristinate ai valori predefiniti',
      studio_availability_note:
        'Le impostazioni di disponibilità sono progettate principalmente per studi di registrazione. Puoi modificarle in seguito nella dashboard se necessario.',
      skip_availability_note:
        'Puoi saltare questo passaggio e configurare la disponibilità più tardi nella dashboard. Queste impostazioni aiutano ad automatizzare il processo di prenotazione e l’esperienza del cliente.',
    },

    availability: {
      cross_day_description:
        'Consenti prenotazioni che attraversano la mezzanotte (es. 23:00 - 2:00)',
      max_cross_day_hours_help: 'Ore massime che una prenotazione può estendersi tra giorni',
      weekend_crossover_help:
        'Permetti prenotazioni che si estendono dal weekend ai giorni feriali o viceversa',
      same_day_start_help:
        'La prenotazione deve iniziare e terminare nello stesso giorno di calendario',
      next_day: 'Giorno successivo',
      cross_midnight_schedule: 'Programma che attraversa la mezzanotte:',
      next_day_suffix: 'giorno successivo',
      advance_booking_help: 'Quanti giorni in anticipo i clienti possono prenotare',
      min_notice_help: 'Ore minime prima della prenotazione',
      max_duration_help: 'Durata massima della prenotazione',
      buffer_time_help: 'Tempo di pausa tra prenotazioni',
      auto_approve_help:
        'Approva automaticamente le richieste di prenotazione senza revisione manuale',
      back_to_back_help: 'Consenti di pianificare prenotazioni consecutive',
      slot_duration_help: 'Durata predefinita per le fasce di prenotazione',
      time_slots_explanation:
        'Le fasce orarie saranno generate in base agli orari di lavoro e all’unità selezionata. I clienti potranno scegliere tra le fasce disponibili durante la prenotazione.',
      settings_apply_note:
        'Le impostazioni attuali saranno applicate al termine della configurazione',
    },
    tabs: {
      working_hours: 'Orari di lavoro',
      booking_rules: 'Regole di prenotazione',
      time_slots: 'Fasce orarie',
    },
    sections: {
      weekly_schedule: 'Programma settimanale',
      weekly_schedule_description:
        'Imposta gli orari di apertura del tuo studio per ogni giorno della settimana. Abilita la modalità 24 ore o imposta orari che attraversano la mezzanotte (es. 22:00 - 06:00)',
      cross_day_policy: 'Politica di prenotazione tra giorni',
      booking_configuration: 'Configurazione prenotazioni',
      booking_configuration_description: 'Configura le regole e le restrizioni di prenotazione',
      time_slot_configuration: 'Configurazione fasce orarie',
      time_slot_description: 'Configura intervalli e fasce orarie di prenotazione',
    },
    controls: {
      enable_cross_day: 'Abilita prenotazioni tra giorni',
      max_cross_day_hours: 'Ore massime tra giorni',
      allow_weekend_crossover: 'Consenti incrocio weekend',
      require_same_day_start: 'Richiedi inizio nello stesso giorno',
      twentyFourHours: '24h',
      start_time: 'Ora di inizio',
      end_time: 'Ora di fine',
      advance_booking_days: 'Giorni di prenotazione anticipata',
      minimum_notice_hours: 'Preavviso minimo (ore)',
      max_session_duration: 'Durata massima sessione (minuti)',
      buffer_time_minutes: 'Tempo di pausa (minuti)',
      auto_approve_bookings: 'Approva automaticamente le prenotazioni',
      allow_back_to_back: 'Consenti prenotazioni consecutive',
      time_slot_unit: 'Unità fascia oraria',
      default_slot_duration: 'Durata predefinita fascia (minuti)',
    },
    quick_setup_content: {
      studio_description:
        'Crea un profilo professionale per il tuo studio musicale con funzionalità e impostazioni essenziali',
      org_description:
        'Crea la tua organizzazione con una configurazione di base e funzionalità essenziali',
      organization_name_required: "Nome dell'organizzazione *",
      description_required: 'Descrizione *',
      studio_placeholder: 'Descrivi il tuo studio di registrazione, servizi e specialità...',
      org_placeholder: 'Descrivi i servizi e la missione della tua organizzazione...',
      optional: 'Facoltativo',
      change_logo: 'Cambia logo',
      upload_logo: 'Carica logo',
      default_settings_applied: 'Impostazioni predefinite applicate',
      detailed_setup: 'Configurazione dettagliata',
      standard_working_hours: 'Orario di lavoro standard (9:00 - 18:00, Lunedì-Venerdì)',
      basic_booking_settings: 'Impostazioni di prenotazione di base con fasce di 1 ora',
      auto_approval: 'Approvazione automatica abilitata per prenotazioni rapide',
      advance_booking: 'Finestra di prenotazione anticipata di 7 giorni',
      buffer_time: 'Intervallo di 30 minuti tra le sessioni',
      customize_later_note:
        'Tutte le impostazioni possono essere personalizzate in seguito nella dashboard.',
      changed_mind: 'Hai cambiato idea?',
      switch_to_detailed:
        'Passa alla configurazione dettagliata per il pieno controllo sulla configurazione della tua organizzazione.',
    },
    showcase: {
      title: 'Vetrina musicale',
      description:
        'Mostra le tue opere musicali, artisti in evidenza e il tuo portfolio creativo per attirare clienti e dimostrare le capacità del tuo studio',
      enable_showcase: 'Abilita vetrina musicale',
      visibility_note:
        "Crea una vetrina pubblica visibile nella pagina del profilo dell'organizzazione",
      title_placeholder: 'Vetrina del mio studio',
      description_placeholder: 'Descrivi la tua vetrina musicale...',
      platform_integration_note:
        'Potrai aggiungere musica da Spotify, SoundCloud e altre piattaforme tramite la gestione della vetrina.',
      studio_specific_note:
        'Le vetrine musicali sono progettate principalmente per studi di registrazione e locali musicali.',
      dashboard_config_note:
        'Puoi saltare questo passaggio e configurare la vetrina musicale più tardi nella dashboard.',
    },
    buttons: {
      reset_to_defaults: 'Ripristina predefiniti',
    },
    roles: {
      custom_role: 'Ruolo personalizzato',
    },
  },
  billing: 'fatturazione',
  settings: 'Impostazioni',
  network: 'Rete',
  thanks_join_invite: 'Grazie per la tua partecipazione!',
  account_created_check_email:
    "Il tuo account e' stato creato. Verifica la tua email per completare l'attivazione",
  verify_before_expire: 'Verifica prima di scadere',
  if_mistake_contact_instadrink: 'Se houver um erro, entre em contato com o I.D',
  invitation_rejected: 'Convite rejeitado',
  invite_owner: 'Vorrei invitare un proprietario',
  invite_referrer: 'Vorrei invitare un PromoBooster',
  invite_ambassador: 'Vorrei invitare un ambasciatore',
  invite_more_users: 'Invita altri utenti',
  your_organisation_staff: 'Il tuo personal della organizzazione',
  invite_more_staff: 'Invita altri personale',
  since: 'Da',
  Download_Invoice: 'Download fattura',
  check_invitation_list: "Controlla l'elenco degli inviti",
  'invitation.continuation_title': 'Invito già inviato!',
  'invitation.continuation_body':
    'È già stato inviato un invito a questo indirizzo email. Controlla la tua casella di posta (e la cartella spam) e clicca sul link di verifica.\n\nSe non trovi l\'email, puoi continuare toccando il pulsante <0>Reinvitare</0>.',
  'invitation.continuation_use_existing': 'Controllo la mia email',
  'invitation.continuation_start_new': 'Reinvitare',
  cancel_successful: 'Invito annullato',
  cancel_failed: "Impossibile annullare l'invito",
  password_required: 'La password è obbligatoria',
  password_short: 'La password è troppo corta: deve contenere almeno 8 caratteri.',
  password_long: 'La password è troppo lunga: deve contenere al massimo 128 caratteri.',
  password_alpha: 'La password può contenere solo lettere latine.',
  password_lowercase: 'La password deve contenere almeno una lettera minuscola.',
  password_uppercase: 'La password deve contenere almeno una lettera maiuscola.',
  password_number: 'La password deve contenere almeno un numero.',
  password_special: 'La password deve contenere almeno un carattere speciale.',
  password_no_repeat: 'La password non deve ripetere lo stesso carattere tre volte di seguito.',
  confirm_password_match: 'Le password devono coincidere',
  confirm_password_required: 'La conferma della password è obbligatoria',
  invitation: {
    status: {
      pending: 'In attesa',
      accepted: 'Accettata',
      canceled: 'Annullata',
      rejected: 'Rifiutata',
      expired: 'Scaduta',
    },
  },
  studio: {
    customization: {
      title: 'Personalizzazione dello Studio',
      subtitle: 'Personalizza come appare il tuo studio ai clienti e visitatori',
      resetTooltip: 'Ripristina alle impostazioni predefinite',
      previewTooltip: 'Anteprima personalizzazione',
      saveChanges: 'Salva Modifiche',
      enableCustomization: 'Abilita Personalizzazione',
      enableDescription:
        'Quando abilitato, le tue impostazioni personalizzate saranno applicate alla pagina dello studio',
      choosePersonality: 'Scegli la Personalità dello Studio',
      tabs: {
        layout: 'Layout',
        theme: 'Tema',
        content: 'Contenuto',
      },
      layout: {
        heroStyle: 'Stile Hero',
        heroStyles: {
          fullscreen: 'Schermo Intero',
          banner: 'Banner',
          split: 'Diviso',
          minimal: 'Minimale',
        },
        logoPosition: 'Posizione Logo',
        logoPositions: {
          overlayLeft: 'Sovrapposizione Sinistra',
          center: 'Centro',
          above: 'Sopra',
          side: 'Lato',
        },
        ctaPosition: 'Posizione Call-to-Action',
        ctaPositions: {
          hero: 'In Hero',
          below: 'Sotto Hero',
          floating: 'Fluttuante',
          multiple: 'Posizioni Multiple',
        },
        sectionOrder: 'Ordine delle Sezioni',
        sectionOrderDescription: "L'ordine in cui le sezioni appaiono sulla pagina dello studio",
      },
    },
    settings: {
      title: 'Impostazioni Generali',
      subtitle: 'Configura le impostazioni e le preferenze del tuo studio',
      tabs: {
        general: 'Generale',
        bookingRules: 'Regole di Prenotazione',
        pricingPayment: 'Prezzi e Pagamenti',
        notifications: 'Notifiche',
        studioBusiness: 'Business dello Studio',
      },
      general: {
        studioName: 'Nome dello Studio',
        studioNameHelp: 'Il nome del tuo studio come mostrato ai clienti',
        emailAddress: 'Indirizzo Email',
        emailAddressHelp: 'Indirizzo email principale per la comunicazione con lo studio',
        phoneNumber: 'Numero di Telefono',
        phoneNumberHelp: 'Numero di contatto per le richieste dei clienti',
        address: 'Indirizzo',
        addressHelp: 'Indirizzo fisico dello studio',
        description: 'Descrizione',
        descriptionHelp: 'Breve descrizione del tuo studio e dei suoi servizi',
        saveButton: 'Salva Impostazioni Generali',
        noLocationsFound: 'Nessuna posizione trovata',
      },
      bookingRules: {
        title: 'Regole di Prenotazione',
        description: 'Configura come i clienti possono prenotare il tuo studio',
        requiresApproval: 'Richiede Approvazione',
        requiresApprovalHelp: 'Approva manualmente le prenotazioni prima della conferma',
        autoApprove: 'Approva Automaticamente le Prenotazioni',
        autoApproveHelp:
          'Approva automaticamente le richieste di prenotazione senza revisione manuale',
        cancellationPolicy: 'Politica di Cancellazione',
        cancellationPolicyHelp: 'Dettagli della tua politica di cancellazione',
        cancellationWindow: 'Finestra di Cancellazione (ore)',
        cancellationWindowHelp: 'Ore prima della prenotazione per la cancellazione gratuita',
        depositRequired: 'Deposito Richiesto',
        depositRequiredHelp: 'Richiedi un deposito per confermare le prenotazioni',
        depositPercentage: 'Percentuale del Deposito',
        depositPercentageHelp: 'Percentuale del totale richiesta come deposito',
        minAdvanceBooking: 'Prenotazione Anticipata Minima (ore)',
        minAdvanceBookingHelp: 'Ore minime in anticipo per prenotare',
        maxAdvanceBooking: 'Prenotazione Anticipata Massima (giorni)',
        maxAdvanceBookingHelp: 'Giorni massimi in anticipo per prenotare',
        bufferTime: 'Tempo di Preparazione (minuti)',
        bufferTimeHelp: 'Tempo tra le prenotazioni per la preparazione',
        bookingSpacingTitle: 'Spaziatura e Approvazione Prenotazioni',
        allowBackToBack: 'Consenti Prenotazioni Consecutive',
        allowBackToBackHelp:
          'Consenti alle prenotazioni di iniziare immediatamente dopo la fine della precedente',
        saveButton: 'Salva Regole di Prenotazione',
        saveSuccess: 'Regole di prenotazione salvate con successo',
        saveFailed: 'Impossibile salvare le regole di prenotazione',
      },
      paymentSettings: {
        title: 'Impostazioni di Pagamento',
        subtitle: 'Configura come vengono raccolti i pagamenti per le prenotazioni',
        paymentMode: 'Modalità di Pagamento',
        paymentModeRequired: 'La modalità di pagamento è obbligatoria',
        invalidPaymentMode: 'Modalità di pagamento non valida',

        // Payment Modes
        manualMode: 'Conferma Manuale (Nessun Pagamento Richiesto)',
        manualModeDescription:
          'Le prenotazioni vengono confermate senza pagamento. Il proprietario conferma manualmente.',
        fullMode: 'Pagamento Completo per Confermare la Prenotazione',
        fullModeDescription:
          'Il cliente deve pagare il 100% in anticipo per confermare la prenotazione.',
        depositMode: 'Pagamento di Acconto',
        depositModeDescription:
          'Il cliente paga una percentuale di acconto. Il saldo rimanente è dovuto successivamente.',
        holdMode: 'Autorizzazione di Pagamento (Pre-autorizzazione)',
        holdModeDescription:
          "Porre un'autorizzazione sul metodo di pagamento del cliente. Addebitare dopo la conferma della prenotazione da parte del proprietario.",

        // Deposit Settings
        depositConfiguration: 'Configurazione Acconto',
        depositConfigurationHelp:
          'Configura la percentuale di acconto e le restrizioni opzionali di prenotazione anticipata',
        depositPercentage: 'Percentuale di Acconto',
        depositPercentageHelp: 'Percentuale del prezzo totale richiesta come acconto (0-100%)',
        depositPercentageMin: 'La percentuale di acconto deve essere almeno 0%',
        depositPercentageMax: 'La percentuale di acconto non può superare il 100%',
        depositPercentageRequired:
          'La percentuale di acconto è obbligatoria per la modalità acconto',

        restrictDepositToAdvanceDays: 'Limita Acconto alle Prenotazioni Anticipate',
        restrictDepositToAdvanceDaysHelp:
          'Richiedi un acconto solo per le prenotazioni effettuate con X giorni di anticipo',
        depositOnlyForAdvanceDays: 'Acconto Richiesto per Giorni di Anticipo',
        depositOnlyForAdvanceDaysHelp:
          'Richiedi un acconto solo per le prenotazioni effettuate con questo numero di giorni di anticipo',
        depositOnlyForAdvanceDaysMin: 'I giorni devono essere 0 o più',
        depositOnlyForAdvanceDaysRequired: 'Specifica il numero di giorni di anticipo',

        // Payment Hold
        paymentHoldTitle: 'Autorizzazione di Blocco Pagamento',
        paymentHoldDescription:
          "Verrà posta un'autorizzazione di pre-autorizzazione sul metodo di pagamento del cliente. L'importo non verrà addebitato fino a quando non confermi manualmente la prenotazione. L'autorizzazione di solito scade dopo 7 giorni se non confermata.",

        // Payment Methods
        acceptedMethodsTitle: 'Metodi di Pagamento Accettati',
        acceptedMethodsSubtitle: 'Seleziona i metodi di pagamento che accetti',
        atLeastOneMethodRequired:
          'Almeno un metodo di pagamento deve essere selezionato quando il pagamento è richiesto',

        acceptCash: 'Contanti',
        acceptCashHelp: 'Accetta pagamenti in contanti sul posto',
        acceptCard: 'Carta (Sul Posto)',
        acceptCardHelp: 'Accetta pagamenti con carta sul posto',
        acceptOnlinePayment: 'Pagamento Online',
        acceptOnlinePaymentHelp: 'Accetta pagamenti online tramite Stripe',

        // Stripe
        stripeIntegrationTitle: 'Integrazione Stripe Richiesta',
        stripeIntegrationDescription:
          "Per accettare pagamenti online, devi collegare il tuo account Stripe. Contatta il supporto per configurare l'integrazione Stripe Connect.",
        stripeAccountIdRequired: "L'ID account Stripe è obbligatorio per i pagamenti online",

        // Messages
        saveButton: 'Salva Impostazioni di Pagamento',
        saveSuccess: 'Impostazioni di pagamento salvate con successo',
        saveFailed: 'Impossibile salvare le impostazioni di pagamento',
        applyToNewBookings:
          'Le impostazioni di pagamento verranno applicate a tutte le nuove prenotazioni. Le prenotazioni esistenti rimangono invariate.',

        // Days
        days: 'giorni',
      },
      notifications: {
        title: 'Impostazioni di Notifica',
        description: 'Gestisci come tu e i tuoi clienti ricevete le notifiche',
        emailNotifications: 'Notifiche Email',
        smsNotifications: 'SMS Notifications',
        emailNotificationsHelp: 'Abilita le notifiche via email',
        smsNotificationsHelp: 'Ricevere notifiche via SMS',
        whatsappNotifications: 'Notifiche WhatsApp',
        whatsappNotificationsHelp: 'Abilita le notifiche WhatsApp',
        customerNotifications: 'Notifiche Clienti',
        notifyOnBooking: 'Notifica alla Nuova Prenotazione',
        notifyOnBookingHelp: 'Invia una notifica al cliente quando viene creata una prenotazione',
        notifyOnStatusChange: 'Notifica al Cambio di Stato',
        notifyOnStatusChangeHelp: 'Notifica al cliente quando cambia lo stato della prenotazione',
        notifyBeforeSession: 'Promemoria Prima della Sessione',
        notifyBeforeSessionHelp: 'Invia un promemoria prima della sessione programmata',
        ownerNotifications: 'Notifiche Proprietario',
        notifyOwnerOnBooking: 'Notifica al Proprietario per Nuove Prenotazioni',
        notifyOwnerOnBookingHelp:
          'Avvisa il proprietario dello studio delle nuove richieste di prenotazione',
        notifyOwnerOnCancellation: 'Notifica al Proprietario delle Cancellazioni',
        notifyOwnerOnCancellationHelp:
          'Avvisa il proprietario dello studio delle cancellazioni di prenotazione',
      },
      studioBusiness: {
        title: 'Impostazioni Business dello Studio',
        description: 'Gestisci la visibilità pubblica e le impostazioni business del tuo studio',
        isPublic: 'Studio Pubblico',
        isPublicHelp: 'Rendi lo studio visibile nelle ricerche e negli elenchi pubblici',
        acceptBookings: 'Accetta Prenotazioni',
        acceptBookingsOn: 'Il tuo studio sta accettando nuove richieste di prenotazione',
        acceptBookingsOff: 'Le nuove prenotazioni sono temporaneamente disabilitate',
        acceptsBookings: 'Accetta Prenotazioni',
        acceptsBookingsHelp: 'Accetta nuove richieste di prenotazione',
        musicStyles: 'Stili Musicali',
        musicStylesHelp:
          'Seleziona gli stili musicali supportati dal tuo studio (tieni premuto Ctrl/Cmd per la selezione multipla)',
        country: 'Paese',
        musicStylePlaceholder: 'Aggiungi uno stile o genere musicale (es: Rock, Jazz, Hip Hop)',
        noMusicStyles:
          'Nessuno stile musicale aggiunto finora. Aggiungine per aiutare i clienti a trovare il tuo studio.',
        currency: 'Valuta',
        timezone: 'Fuso Orario',
        language: 'Lingua',
        websiteUrl: 'URL del Sito Web',
        websiteUrlHelp: 'Sito web del tuo studio (opzionale)',
        socialMedia: 'Social Media',
        socialMediaHelp: 'Link ai tuoi profili social',
        saveButton: 'Salva Impostazioni Business dello Studio',
        saveSuccess: 'Impostazioni business dello studio salvate con successo',
        saveFailed: 'Impossibile salvare le impostazioni business dello studio',
      },
      validation: {
        nameRequired: 'Il nome dello studio è obbligatorio',
        emailRequired: "L'indirizzo email è obbligatorio",
        emailInvalid: 'Indirizzo email non valido',
        phoneRequired: 'Il numero di telefono è obbligatorio',
        addressRequired: "L'indirizzo è obbligatorio",
      },
      messages: {
        settingsSaved: 'Impostazioni salvate con successo!',
        saveFailed: 'Impossibile salvare le impostazioni',
        notificationsSaved: 'Impostazioni di notifica salvate con successo!',
        notificationsSaveFailed: 'Impossibile salvare le impostazioni di notifica',
      },
    },
    theme: {
      title: 'Tema dello Studio',
      subtitle:
        "Gestisci l'identità visiva del tuo studio con logo e immagini di copertina personalizzati",
      logoSection: {
        title: 'Logo dello Studio',
        description: 'Carica il logo del tuo studio. Dimensione consigliata: 256x256px, max 2MB',
        changeLogo: 'Cambia Logo',
        uploadLogo: 'Carica Logo',
        removeLogo: 'Rimuovi Logo',
        clickToPreview: 'Clicca per anteprima',
      },
      coverSection: {
        title: 'Immagine di Copertina',
        description:
          "Carica l'immagine di copertina del tuo studio. Dimensione consigliata: 1200x400px, max 5MB",
        changeCoverImage: 'Cambia Immagine di Copertina',
        uploadCoverImage: 'Carica Immagine di Copertina',
        removeCoverImage: 'Rimuovi Immagine di Copertina',
      },
      guidelines: {
        title: 'Linee Guida del Tema',
        logoRequirements: 'Requisiti del Logo',
        logoSpecs: {
          squareFormat: 'Formato quadrato (rapporto 1:1) consigliato',
          minMaxSize: 'Minimo 256x256px, massimo 512x512px',
          format: 'Formato PNG o JPG',
          maxFileSize: 'Dimensione massima del file: 2MB',
          transparentBg: 'Sfondo trasparente preferito per PNG',
        },
        coverRequirements: "Requisiti dell'Immagine di Copertina",
        coverSpecs: {
          landscapeFormat: 'Formato orizzontale (rapporto 3:1) consigliato',
          minSize: 'Minimo 1200x400px',
          format: 'Formato PNG o JPG',
          maxFileSize: 'Dimensione massima del file: 5MB',
          highQuality: 'Le immagini di alta qualità si presentano meglio',
        },
      },
      messages: {
        logoSizeError: 'La dimensione del file del logo deve essere inferiore a 2MB',
        coverSizeError:
          "La dimensione del file dell'immagine di copertina deve essere inferiore a 5MB",
        invalidImageFile: 'Seleziona un file immagine valido',
        logoUpdated: 'Logo aggiornato con successo!',
        logoUpdateFailed: 'Impossibile aggiornare il logo',
        coverUpdated: 'Immagine di copertina aggiornata con successo!',
        coverUpdateFailed: "Impossibile aggiornare l'immagine di copertina",
        confirmRemoveLogo: 'Sei sicuro di voler rimuovere il logo dello studio?',
        confirmRemoveCover: "Sei sicuro di voler rimuovere l'immagine di copertina?",
        logoRemoved: 'Logo rimosso con successo!',
        logoRemoveFailed: 'Impossibile rimuovere il logo',
        coverRemoved: 'Immagine di copertina rimossa con successo!',
        coverRemoveFailed: "Impossibile rimuovere l'immagine di copertina",
      },
      preview: {
        logoTitle: 'Anteprima Logo',
        coverTitle: 'Anteprima Immagine di Copertina',
        close: 'Chiudi',
      },
    },
    showcase: {
      title: 'Vetrina Musicale',
      settings: {
        title: 'Impostazioni Vetrina Musicale',
        subtitle: 'Configura la vetrina musicale del tuo studio per i clienti',
        saveSettings: 'Salva Impostazioni',
        enableShowcase: 'Abilita Vetrina Musicale',
        enableDescription:
          'Quando abilitata, la tua vetrina musicale sarà visibile ai clienti sul profilo del tuo studio',
        showcaseTitle: 'Titolo della Vetrina',
        showcaseTitlePlaceholder: 'es. Le Nostre Ultime Produzioni',
        showcaseDescription: 'Descrizione della Vetrina',
        showcaseDescriptionPlaceholder: 'Descrivi la tua vetrina musicale...',
      },
      tracks: {
        title: 'Brani Musicali',
        subtitle: 'Aggiungi brani musicali per mostrare il lavoro del tuo studio',
        addTrack: 'Aggiungi Brano',
        addFirstTrack: 'Aggiungi Primo Brano',
        editTrack: 'Modifica Brano',
        noTracksYet: 'Nessun brano aggiunto ancora. Aggiungi il tuo primo brano per iniziare!',
        enableShowcaseFirst: 'Abilita la vetrina musicale sopra per iniziare ad aggiungere brani',
        trackCount: 'Brani Musicali ({{count}})',
        hidden: 'Nascosto',
        by: 'di',
      },
      trackDialog: {
        addTitle: 'Aggiungi Brano',
        editTitle: 'Modifica Brano',
        trackTitle: 'Titolo del Brano *',
        trackTitlePlaceholder: 'Inserisci il titolo del brano',
        artist: 'Artista',
        artistPlaceholder: "Nome dell'artista o della band",
        platform: 'Piattaforma *',
        url: 'URL *',
        description: 'Descrizione',
        descriptionPlaceholder: 'Descrizione o note opzionali su questo brano',
        cancel: 'Annulla',
        add: 'Aggiungi',
        update: 'Aggiorna',
        addTrackButton: 'Aggiungi Brano',
        updateTrackButton: 'Aggiorna Brano',
      },
      platforms: {
        youtube: 'YouTube',
        spotify: 'Spotify',
        soundcloud: 'SoundCloud',
        apple_music: 'Apple Music',
        bandcamp: 'Bandcamp',
        other: 'Altro',
      },
      urlHints: {
        youtube: 'es. https://www.youtube.com/watch?v=dQw4w9WgXcQ o https://youtu.be/dQw4w9WgXcQ',
        spotify: 'es. https://open.spotify.com/track/4uLU6hMCjMI75M1A2tKUQC',
        soundcloud: 'es. https://soundcloud.com/artista/nome-brano',
        apple_music: 'es. https://music.apple.com/us/album/nome-canzone/id123456789?i=123456789',
        bandcamp: 'es. https://artista.bandcamp.com/track/nome-canzone',
        other: 'Inserisci qualsiasi URL di piattaforma musicale',
      },
      actions: {
        openLink: 'Apri link',
        hideTrack: 'Nascondi brano',
        showTrack: 'Mostra brano',
        editTrack: 'Modifica brano',
        removeTrack: 'Rimuovi brano',
      },
      messages: {
        settingsSaved: 'Impostazioni vetrina salvate con successo!',
        settingsSaveFailed: 'Impossibile salvare le impostazioni della vetrina',
        enterTitle: 'Inserisci un titolo per il brano',
        enterUrl: 'Inserisci un URL per il brano',
        invalidUrl: 'Formato URL {{platform}} non valido',
        trackUpdated: 'Brano aggiornato con successo!',
        trackAdded: 'Brano aggiunto con successo!',
        trackSaveFailed: 'Impossibile salvare il brano',
        confirmRemove: 'Sei sicuro di voler rimuovere "{{title}}" dalla vetrina?',
        trackRemoved: 'Brano rimosso con successo!',
        trackRemoveFailed: 'Impossibile rimuovere il brano',
        trackHidden: 'Brano nascosto con successo!',
        trackShown: 'Brano mostrato con successo!',
        trackToggleFailed: 'Impossibile modificare la visibilità del brano',
        tracksReordered: 'Brani riordinati con successo!',
        tracksReorderFailed: 'Impossibile riordinare i brani',
      },
    },
    availability: {
      title: 'Disponibilità dello Studio',
      subtitle:
        'Configura gli orari di apertura del tuo studio, gli slot di prenotazione e le regole di disponibilità',
      loading: 'Caricamento impostazioni di disponibilità...',
      loadError:
        'Impossibile caricare le impostazioni di disponibilità. Prova ad aggiornare la pagina.',
      tabs: {
        workingHours: 'Orari di Lavoro',
        bookingRules: 'Regole di Prenotazione',
        timeSlots: 'Slot Temporali',
      },
      daysOfWeek: {
        monday: 'Lunedì',
        tuesday: 'Martedì',
        wednesday: 'Mercoledì',
        thursday: 'Giovedì',
        friday: 'Venerdì',
        saturday: 'Sabato',
        sunday: 'Domenica',
      },
      workingHours: {
        title: 'Orario Settimanale',
        description:
          'Imposta gli orari di apertura del tuo studio per ogni giorno della settimana. Abilita la modalità 24 ore o imposta orari che attraversano la mezzanotte (es. 22:00 alle 06:00 del giorno successivo)',
        startTime: 'Orario di Inizio',
        endTime: 'Orario di Fine',
        is24Hours: '24h',
        nextDay: 'giorno successivo',
        crossMidnightSchedule: 'Orario attraversa mezzanotte:',
      },
      crossDayPolicy: {
        title: 'Politica Prenotazioni Multi-Giorno',
        enableCrossDayBookings: 'Abilita Prenotazioni Multi-Giorno',
        enableDescription:
          'Consenti prenotazioni che si estendono oltre la mezzanotte (es. 23:00 alle 02:00)',
        maxCrossDayHours: 'Ore Massime Multi-Giorno',
        maxCrossDayHoursHelp:
          'Numero massimo di ore che una prenotazione può estendersi su più giorni',
        allowWeekendCrossover: 'Consenti Passaggio Weekend',
        allowWeekendCrossoverHelp:
          'Consenti alle prenotazioni di passare dal weekend ai giorni feriali o viceversa',
        requireSameDayStart: 'Richiedi Inizio Stesso Giorno',
        requireSameDayStartHelp:
          'La prenotazione deve iniziare e terminare nello stesso giorno calendario',
      },
      bookingRules: {
        title: 'Configurazione Prenotazioni',
        description: 'Configura le regole e le restrizioni di prenotazione',
        advanceBookingDays: 'Giorni di Prenotazione Anticipata',
        advanceBookingDaysHelp: 'Quanti giorni in anticipo i clienti possono prenotare',
        minBookingNotice: 'Preavviso Minimo (ore)',
        minBookingNoticeHelp: 'Ore minime prima della prenotazione',
        maxBookingDuration: 'Durata Massima Sessione (minuti)',
        maxBookingDurationHelp: 'Durata massima della prenotazione',
        bufferTime: 'Tempo di Pausa (minuti)',
        bufferTimeHelp: 'Tempo di pausa tra le prenotazioni',
        autoApproveBookings: 'Approva automaticamente le prenotazioni',
        autoApproveBookingsHelp:
          'Approva automaticamente le richieste di prenotazione senza revisione manuale',
        allowBackToBackBookings: 'Consenti prenotazioni consecutive',
        allowBackToBackBookingsHelp: 'Consenti di pianificare prenotazioni consecutive',
      },
      timeSlots: {
        title: 'Configurazione Slot Temporali',
        description: 'Configura gli slot temporali e gli intervalli di prenotazione',
        timeSlotUnit: 'Unità Slot Temporale',
        timeSlotDuration: 'Durata Predefinita Slot (minuti)',
        timeSlotDurationHelp: 'Durata predefinita degli slot di prenotazione',
        info: "Gli slot temporali verranno generati in base agli orari di lavoro e all'unità di tempo selezionata. I clienti possono selezionare tra gli slot disponibili durante la prenotazione.",
        units: {
          '15min': '15 minuti',
          '30min': '30 minuti',
          '1hr': '1 ora',
        },
      },
      validation: {
        advanceBookingDaysRequired: 'I giorni di prenotazione anticipata sono richiesti',
        minBookingNoticeRequired: 'Il preavviso minimo di prenotazione è richiesto',
        maxBookingDurationRequired: 'La durata massima della prenotazione è richiesta',
        timeSlotDurationRequired: 'La durata dello slot temporale è richiesta',
        bufferTimeRequired: 'Il tempo di pausa è richiesto',
      },
      actions: {
        reset: 'Ripristina',
        saveSettings: 'Salva Impostazioni',
      },
      messages: {
        settingsSaved: 'Impostazioni di disponibilità salvate con successo!',
        saveFailed: 'Si è verificato un errore. Riprova.',
      },
    },
  },
  method: 'Metodo',

  manual: 'Manuale',
  full: 'Completo',
  deposit: 'Deposito',
  hold: 'Blocco pagamento',

  // Import modular translations
  ...globalDashboardIt,
  ...privacyIt,
  ...analyticsIt,
  ...stripeConnectIt,
};

export default it;
